import { useRootService } from '@kaokei/use-vue-service';
import defaultInvalidImage from '~/assets/image/icon/icon-broken.svg';
import { ZoneService } from '~/services/zone.service';
import { URL_PATTERN, URL_PATTERN_STRICT } from '~/utils/constant';
import { isValidHost } from '~/utils/is-valid-host';

const zoneService = useRootService(ZoneService);

const VALID_CDN_LIST = [
  'public.hetaoimg.com',
  'oj-forum.cdn.hetaoedu.com',
  'oj-forum-testing.cdn.hetaoedu.com',
];

export const toolbars: any[] = [
  'bold',
  'underline',
  'italic',
  '-',
  'strikeThrough',
  'title',
  'sub',
  'sup',
  'quote',
  'unorderedList',
  'orderedList',
  'task', // ^2.4.0
  '-',
  'codeRow',
  'code',
  'link',
  'image',
  0,
  'table',
  'mermaid',
  'katex',
  '-',
  'revoke',
  'next',
  'save',
  '=',
  'pageFullscreen',
  'fullscreen',
  'preview',
  'previewOnly',
  'htmlPreview',
  'catalog',
  'github',
];

export const toolbars4post: any[] = [
  'bold',
  'italic',
  '-',
  'strikeThrough',
  'title',
  'sub',
  'sup',
  'quote',
  'unorderedList',
  'orderedList',
  'task', // ^2.4.0
  '-',
  'codeRow',
  'code',
  'link',
  'image',
  0,
  'table',
  'mermaid',
  'katex',
  '-',
  'revoke',
  'next',
  '=',
  'pageFullscreen',
  'fullscreen',
  'preview',
  'previewOnly',
  'htmlPreview',
  'catalog',
];

export const toolbars4comment: any[] = [
  'bold',
  'italic',
  '-',
  'strikeThrough',
  'title',
  'sub',
  'sup',
  'quote',
  'unorderedList',
  'orderedList',
  'task', // ^2.4.0
  '-',
  'codeRow',
  'code',
  'link',
  'image',
  0,
  'table',
  'mermaid',
  'katex',
  '-',
  'revoke',
  'next',
  '=',
  'pageFullscreen',
  'fullscreen',
  'preview',
  'previewOnly',
  'htmlPreview',
  'catalog',
];

export function checkValidImgUrl(imgUrl: string) {
  try {
    const urlObj = new URL(imgUrl);
    const domain = urlObj.hostname;
    return VALID_CDN_LIST.includes(domain) ? imgUrl : defaultInvalidImage;
  } catch (error) {
    return defaultInvalidImage;
  }
}

export function isHostLinkUrl(url: string) {
  try {
    const isValid = URL_PATTERN.test(url);
    if (isValid) {
      let newurl = url;
      if (!URL_PATTERN_STRICT.test(url)) {
        newurl = `https://${url}`;
      }
      const urlObj = new URL(newurl);
      return isValidHost(urlObj.hostname);
    }
  } catch (error) {
    return true;
  }
  return true;
}

export function getThirdPartyUrl(url: string) {
  return `/${zoneService.zone}/link?target=${encodeURIComponent(url)}`;
}

export function isConsumerEditor(type: string) {
  return type === 'post' || type === 'comment';
}
